<div [agprLoading]="loading" [loadingSmallIndicator]="smallIndicator" #chartElement class="agpr-chart"></div>
